<template>
  <GenericPage page-shortname="contact">
    <ProgressSpinner  v-if="loading"/>
    <Panel header="Contact" class="contactFormPanel" v-show="!loading">
      <form class="contactForm" @submit.prevent="contactFormSubmitted">         
        <div class="line full-line">
          <label for="contactFromLastName" :class="{'p-error':v$.lastName.$invalid && submitted}">Votre nom et prénom : </label>          
          
          <InputGroup>
            <InputText 
              type="text" 
              id="contactFromLastName"
              v-model="formData.lastName" 
              required="required" 
              :class="{'p-invalid':v$.lastName.$invalid && submitted}"
              />
          </InputGroup>
          <span v-if="v$.lastName.$error && submitted">
              <span id="email-error" v-for="(error, index) of v$.lastName.$errors" :key="index">
              <small class="p-error">{{error.$message}}</small>
              </span>
          </span>
          <small v-else-if="(v$.lastName.$invalid && submitted) || v$.lastName.$pending.$response" class="p-error">
            <template v-if="v$.lastName.required.$invalid">{{v$.lastName.required.$message.replace('Value', 'Nom')}}</template>
          </small>
        </div>


        <!--
        <div class="line">
          <label for="contactFromFirstName" :class="{'p-error':v$.firstName.$invalid && submitted}">Votre prénom : </label>          
          <InputGroup>
            
            <InputText 
              type="text" 
              id="contactFromFirstName"
              v-model="formData.firstName" 
              required="required" 
              :class="{'p-invalid':v$.firstName.$invalid && submitted}"
              />
          </InputGroup>
          <span v-if="v$.firstName.$error && submitted">
              <span id="email-error" v-for="(error, index) of v$.firstName.$errors" :key="index">
              <small class="p-error">{{error.$message}}</small>
              </span>
          </span>
          <small v-else-if="(v$.firstName.$invalid && submitted) || v$.firstName.$pending.$response" class="p-error">
            <template v-if="v$.firstName.required.$invalid">{{v$.firstName.required.$message.replace('Value', 'Nom')}}</template>
          </small>
        </div>
        -->
        <div class="line">
          <label for="contactFromEmail" :class="{'p-error':v$.email.$invalid && submitted}">Votre adresse email : </label>
          <InputGroup>
            <InputGroupAddon><i class="pi pi-at" /></InputGroupAddon>
            
            <InputText 
              type="email" 
              id="contactFromEmail"
              v-model="formData.email" 
              required="required" 
              :class="{'p-invalid':v$.email.$invalid && submitted}"
              />
          </InputGroup>          
          <span v-if="v$.email.$error && submitted">
              <span id="email-error" v-for="(error, index) of v$.email.$errors" :key="index">
              <small class="p-error">{{error.$message}}</small>
              </span>
          </span>
          <small v-else-if="(v$.email.$invalid && submitted) || v$.email.$pending.$response" class="p-error">
            <template v-if="v$.email.required.$invalid">{{v$.email.required.$message.replace('Value', 'Email')}}</template>
            <template v-if="v$.email.email.$invalid">{{v$.email.email.$message.replace('Value', 'Email')}}</template>            
          </small>
        </div>  
 
        <div class="line">
          <label for="contactFromPhone" :class="{'p-error':v$.phone.$invalid && submitted}">Votre téléphone : </label>
          <InputGroup>
            <InputGroupAddon><i class="pi pi-phone" /></InputGroupAddon>
            
            <InputText 
              type="phone" 
              id="contactFromPhone"
              v-model="formData.phone" 
              required="required" 
              :class="{'p-invalid':v$.phone.$invalid && submitted}"
              />
          </InputGroup>
          <span v-if="v$.phone.$error && submitted">
              <span id="email-error" v-for="(error, index) of v$.phone.$errors" :key="index">
              <small class="p-error">{{error.$message}}</small>
              </span>
          </span>
          <small v-else-if="(v$.phone.$invalid && submitted) || v$.phone.$pending.$response" class="p-error">
            <template v-if="v$.phone.required.$invalid">{{v$.phone.required.$message.replace('Value', 'Téléphone')}}</template>
          </small>
        </div>  

        <div class="line">
          <label for="contactDate">Date : </label>          
          <InputGroup>
            
            <InputText 
              type="text" 
              id="contactDate"
              v-model="formData.date" 
              />
          </InputGroup>
        </div>

        <div class="line">
          <label for="nbConvives">Nombre de convives : </label>          
          <InputGroup>            
            <InputText 
              type="text" 
              id="nbConvives"
              v-model="formData.nbConvives" 
              placeholder=""
              />
          </InputGroup>
        </div>

        <div class="line">
          <label for="eventType">Type d'évènement : </label>          
          <InputGroup>            
            <InputText 
              type="text" 
              id="eventType"
              v-model="formData.eventType" 
              placeholder="Anniversaire, mariage, séminaire d'entreprise, retraite bien-être, EVJF etc."
              />
          </InputGroup>
        </div>

        <div class="line">
          <label for="priceRange">Fourchette de prix : </label>          
          <InputGroup>            
            <InputText 
              type="text" 
              id="priceRange"
              v-model="formData.priceRange" 
              placeholder="Prix par personne ou enveloppe globale"
              />
          </InputGroup>
        </div>

        <div class="line forTextarea">
          <label for="contactMessage">Parlez moi de votre projet : </label>
          <Textarea 
            id="contactMessage"
            v-model="formData.message" 
            required="required" 
            :class="{'p-invalid':v$.message.$invalid && submitted}"
            :autoResize="true" 
            cols="30" 
            rows="1"
            placeholder="Etat d'esprit, contexte, besoin spécifique"
            ></Textarea>                 
          <span v-if="v$.message.$error && submitted">
              <span id="message-error" v-for="(error, index) of v$.message.$errors" :key="index">
              <small class="p-error">{{error.$message}}</small>
              </span>
          </span>
          <small v-else-if="(v$.message.$invalid && submitted) || v$.message.$pending.$response" class="p-error">
            <template v-if="v$.message.required.$invalid">{{v$.message.required.$message.replace('Value', 'Message')}}</template>
          </small>
        </div>
        
          
        <Message severity="error" v-if="contactError">{{contactError}}</Message>

        <div class="buttons-container">
          <Button label="Annuler" icon="pi pi-arrow-left" class="p-button-text p-button-secondary" @click="back"/>
          <Button label="Envoyer le message" icon="pi pi-check" class="p-button-text p-button-success"  @click="contactFormSubmitted"/>
        </div>
      </form>
    </Panel>
  </GenericPage>
</template>
<script>
  
import { ref, reactive, watch, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useToast } from "primevue/usetoast";
import Panel from 'primevue/panel';
import Textarea from 'primevue/textarea';
import Message from 'primevue/message';
import { email, required } from "../misc/i18n-validators";
import api from "../services/api";
import { useVuelidate } from "@vuelidate/core";
import GenericPage from './GenericPage.vue';

export default {
  name: "NewsletterUnsubscribe",
  setup() {
    const toast = useToast();
    const route = useRoute();
    const router = useRouter();

    const formData = reactive({
      email: '',
      date: '',
      nbConvives: '',
      eventType: '',
      priceRange: ''
    });
    const loading = ref(false);

    const emailFromRoute = computed(() => route.params.email);
    watch(emailFromRoute, () => {
      formData.email = emailFromRoute.value;
    });
    
    const rules = {
      email: { required, email },
      //firstName: { required }, // pas
      lastName: { required },
      phone: { required },
      message: { required },
      date: {}
    };
    const submitted = ref(false);
    const contactError = ref('');

    const v$ = useVuelidate(rules, formData);

    const contactFormSubmitted = async () => {
      submitted.value = true;
      const isFormValid = !v$.value.$invalid;
      if(!isFormValid) {
        return false;
      }
      loading.value = true;
      contactError.value = '';
      
      try {

        const fullMessage = `Date : ${formData.date}\nNombre de convives : ${formData.nbConvives}\nType d'évènement : ${formData.eventType}\nFourchette de prix : ${formData.priceRange}\n\nMessage : ${formData.message}`;

        const postData = {
          fromEmail: formData.email || '',
          fromFirstName: formData.firstName || '',
          fromLastName: formData.lastName || '',
          fromPhone: formData.phone || '',
          message: fullMessage,
        };

        const contactResponse = await api.contactForm(postData);
        loading.value = false;
        if(contactResponse.error === false) {
          const msg = 'Votre message a bien été envoyé';
          toast.add({severity:'success', summary: msg, detail: '', life: 5000});
          router.push({name: 'home'});
        }else {
          const msg = 'Erreur inconnue';
          contactError.value = msg;
        }
      }catch(e) {
        const msg = 'Erreur inconnue';
        contactError.value = msg;
      }
      loading.value = false;
      return false;
    };
    
    const back = () => {
      router.go(-1);
    };
    
    return {
      back,
      formData,
      loading,
      contactFormSubmitted,
      contactError,
      submitted,
      v$,
    };
  },
  components: {
    GenericPage,
    Message,
    Panel,
    Textarea,
  }
};
</script>
<style lang="scss">
  .contactFormPanel {
    display: inline-block;
    .p-panel-content {
      background-color: rgba(255, 255, 255, 0.7);
    }
    margin-top: 20px;
  
    form.contactForm {
      width: 100%;
      margin: auto;
      text-align: left;
      display: flex;
      flex-wrap: wrap;
      column-gap: 10px;
      .line {
        margin-bottom: 10px;
        flex: 1 1 calc(50% - 10px);
        min-width: 0;
        @media (max-width: 600px) {
          flex-basis: 100%;
        }
        label {
          display: block;

        }
        span.p-input-icon-left {
          display: block;
          width: 100%;
        }
        input {
          width: 100%;
        }
        textarea {
          width: 100%;
          min-height: 300px;
        }
      }
      .line.forTextarea,
      .line.full-line {
        flex-basis: 100%;
        min-width: 100%;
        display: block;
      }
    }
  }
</style>